import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container ,Spinner } from "react-bootstrap";
import { FlightDetails,FlightCard, FlightInfoForm } from "../../Features/FlightList";
import { NotFound } from "../../components";
import "./FlightList.css";
import { useTranslation } from "../../contexts/TranslationContext";



export default function FlightList({ url }) {
//   const location = useLocation();
//   const { flightsData, flightSearchState, travelers } = location.state || {};
//   console.log("flightSearchState",flightSearchState);
//   console.log("travelers",travelers);

//   const storedData = JSON.parse(localStorage.getItem("lastFlightSearch") || "{}");

//   const initialData = flightsData || storedData.flightsData || [];
//   const initialSearchState = flightSearchState || storedData.flightSearchState || {};
//   const initialTravelers = travelers || storedData.travelers || {}; 
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [errorMessage, setErrorMessage] = useState("");

//   const [data, setData] = useState(initialData);
//   const [searchState, setSearchState] = useState({
//   departure: "",
//   destination: "",
//   leaving: "",
//   travelers: [],
//   ...initialSearchState, 
// });
//   const [searchTravelers, setSearchTravelers] = useState(initialTravelers);

//   const handleSearchResults = async (resultsPromise) => {
//     setLoading(true);   
//     setError(null);
//     setErrorMessage("");

//     try {
//       const results = await resultsPromise;    
//       setData(results);
//     } catch (err) {
//       setError(true);
//       setErrorMessage("Failed to fetch flights.");
//     } finally {
//       setLoading(false);      
//     }
//   };
  const [currentView, setCurrentView] = useState('flightList'); 
  const [selectedOfferData, setSelectedOfferData] = useState(null);

  // Handle continue from FlightCard
  const handleContinueFromFlightCard = (offerData) => {
    setSelectedOfferData(offerData);
    setCurrentView('flightInfo');
  };

  // Handle back from NextComponent
  const handleBackFromNextComponent = () => {
    setCurrentView('flightList');
    setSelectedOfferData(null);
  };


  const { t } = useTranslation();
  const location = useLocation();
  const { flightSearchState, travelers } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState(null);

const handleSearchResults = async (resultsPromise) => {
  setLoading(true);
  setErrorMessage("");
  setData(null);

  try {
    const results = await resultsPromise;
    if (!results?.result?.offers || results.result.offers.length === 0) {
      setErrorMessage("No flights found for your search.");
      setData(null);
    } else {
      setData(results);
    }
  } catch (err) {
    console.error("Error fetching flights:", err);
    // هنا نخزن البيانات اللي رجعت من throw
    setErrorMessage({
      status_code: err.status_code || 500,
      message: err.message || "Failed to fetch flights.",
      result: err.result || [],
    });
    setData(null);
  } finally {
    setLoading(false);
  }
};


  if (currentView === 'flightInfo') {
    return (
      <Container>
        <div className="flight-info-container">
          <FlightInfoForm 
            fligtData={selectedOfferData}
            onBack={handleBackFromNextComponent}
          />
        </div>
      </Container>
    );
  }
  

  return (
    <Container>
      <div className="flight-list-container">
        <FlightDetails
          flightSearchState={flightSearchState}
          travelers={travelers}
          onSearchResults={handleSearchResults}
        ></FlightDetails>

        {loading &&
          Array.from({ length: 6 }).map((_, i) => (
            <div key={`sk-${i}`} className="mb-3">
              <FlightCard loading />
            </div>
          ))}

        {!loading &&
          data?.result?.offers?.length > 0 &&
          data.result.offers.map((offer, idx) => (
            <div key={idx} className="mb-3">
              <FlightCard data={{ result: { offers: [offer] } }} onContinue={handleContinueFromFlightCard} url={url} />
            </div>
          ))}

        {!loading && errorMessage && (
          <NotFound
            errorMessage={`Error ${errorMessage.status_code}: ${errorMessage.message}`}
            description={
              Array.isArray(errorMessage.result)
                ? errorMessage.result
                    .map((err) =>
                      typeof err === "string"
                        ? err
                        : err.ErrorMessage || JSON.stringify(err)
                    )
                    .join(" | ")
                : errorMessage.result || t("TryAdjustingYourFiltersorDates") 
            }
          />
        )}
        {/* <FlightCard data={data}></FlightCard> */}
      </div>
    </Container>
  );
}